import { Component, computed, inject, signal } from '@angular/core';
import { Router } from '@angular/router';

import { TokenService } from '../../core/auth/token.service';
import { DocumentApiService } from '../../core/services/document-api.service';
import { KioskDocument, paginateDocuments } from '../../core/data/documents';
import { FooterComponent } from '../../layout/footer/footer.component';
import { HeaderComponent } from '../../layout/header/header.component';
import { DocumentCardComponent } from '../../shared/components/document-card/document-card.component';
import { DocumentPaginationComponent } from '../../shared/components/document-pagination/document-pagination.component';
import { FooterNavComponent } from '../../shared/components/footer-nav/footer-nav.component';

@Component({
  selector: 'app-document-selection',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    FooterNavComponent,
    DocumentCardComponent,
    DocumentPaginationComponent,
  ],
  templateUrl: './document-selection.component.html',
  styleUrl: './document-selection.component.scss',
})
export class DocumentSelectionComponent {
  private readonly router = inject(Router);
  private readonly tokenService = inject(TokenService);
  private readonly documentApi = inject(DocumentApiService);

  readonly loading = signal(true);
  readonly currentPage = signal(1);

  readonly documents = this.documentApi.documents;
  readonly documentPages = computed(() => paginateDocuments(this.documents()));
  readonly totalPages = computed(() => this.documentPages().length);
  readonly hasDocuments = computed(() => this.documents().length > 0);

  constructor() {
    void this.fetchDocuments();
  }

  private async fetchDocuments(): Promise<void> {
    this.loading.set(true);
    try {
      await this.documentApi.load();
    } finally {
      this.loading.set(false);
      // Reset to first page whenever data is reloaded.
      this.currentPage.set(1);
    }
  }

  onPageChange(page: number): void {
    this.currentPage.set(page);
  }

  isSparseSlide(page: KioskDocument[]): boolean {
    return page.length <= 2;
  }

  onDocumentSelected(documentId: number): void {
    this.documentApi.warmPdf(documentId);
    const mac = this.tokenService.mac;
    void this.router.navigate(['/documents', documentId], {
      queryParams: mac ? { mac } : {},
      queryParamsHandling: 'merge',
    });
  }
}
